<div class="export-dialog">
  <div class="content">
    {{message}}
  </div>
  <mat-checkbox color="primary" class="enclose-checkbox fullWidth" name="enclose-checkbox"
                [(ngModel)]="data.enclose">
    Check this option for attribute values to be enclosed by inverted commas ("value")
  </mat-checkbox>
</div>

